import { call, put, select } from 'redux-saga/effects';
import {
  filePageChanged,
  loaderDisplayChanged,
  selectContentLibraryOpenedFile,
} from 'features/content-library/contentLibrarySlice';
import { signalingContentLibraryFilePageChanged } from 'features/content-library/actions';
import { contentBoard } from 'features/content-whiteboard/utils/contentBoardStateManager';
import {
  initContentWhiteboardDataSaga,
  type InitContentWhiteboardData,
} from 'features/content-whiteboard/sagas/initContentWhiteboardDataSaga';
import { ContentLibraryOpenedFile } from 'features/content-library/types';
import {
  lockedContentChanged,
  selectLockedContent,
} from 'features/layout/features/content/contentSlice';
import { ContentData } from 'features/layout/features/content/types';
import { remoteZoomSynced } from 'features/content-zoom/contentZoomSlice';
import { buildZoomId } from 'features/content-zoom/utils/formatUtils';

export function* onContentLibraryFilePageChangedSaga(
  action: ReturnType<typeof signalingContentLibraryFilePageChanged>
) {
  const { id, page, whiteboardShapes: shapes = [], name = '' } = action.payload.data;

  let isActiveBoard = contentBoard.id === id;

  if (!isActiveBoard && contentBoard.id === null) {
    const openedFile: ContentLibraryOpenedFile | null = yield select(
      selectContentLibraryOpenedFile
    );

    if (openedFile?.id === id) {
      isActiveBoard = true;
    }
  }

  if (isActiveBoard) {
    yield put(loaderDisplayChanged(true));
    yield call(contentBoard.clean);
  }

  yield put(filePageChanged(action.payload.data));

  const lockedContent: ContentData | null = yield select(selectLockedContent);

  if (lockedContent && lockedContent.type === 'file' && lockedContent.id === id) {
    yield put(lockedContentChanged({ ...lockedContent, page }));
    yield put(
      remoteZoomSynced({
        zoomId: buildZoomId(id, page),
        scale: 1,
        offsetX: 0,
        offsetY: 0,
      })
    );
  }

  if (isActiveBoard) {
    const data: InitContentWhiteboardData = {
      id,
      page,
      shapes,
      name,
    };

    yield call(initContentWhiteboardDataSaga, data);
  }
}
